import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

const SignOutModal = ({shouldShow, onSignOut, onClose}) => {

  	return (
		<>
			<Modal  show={shouldShow} centered onHide={onClose} className="app-page-text">
				<Modal.Header closeButton >
					<Modal.Title>Sign Out</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Are you sure you want to sign out?</p>
				</Modal.Body>
				
				<Modal.Footer>
					<Button onClick={() => onClose()} variant="secondary" className="app-modal-cancel-button">
						Cancel
					</Button>
					<Button onClick={() => onSignOut()} variant="danger" className="app-modal-sign-out-button">
						Sign Out
					</Button>
				</Modal.Footer>
			</Modal>
		</>
		
  	);
}

export default SignOutModal;